import { __decorate, __metadata, __param } from "tslib";
import { Symbols } from '@/symbols';
import { inject, injectable } from 'inversify';
import { format } from '@/@core/utils/string';
let CompanyDataAnalysisApi = class CompanyDataAnalysisApi {
    constructor(http, urls) {
        this.http = http;
        this.urls = urls;
    }
    getCompanyDataAnalysisUserPrivilegesSummary(params) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return this.http.post({
            url: this.urls.getCompanyDataAnalysisUserPrivilegesSummary,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        });
    }
    getCompanyDataAnalysisUserPrivileges(params) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return this.http.post({
            url: this.urls.getCompanyDataAnalysisUserPrivileges,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        });
    }
    getCompanyDataAnalysisData(params) {
        return this.http.post({
            url: this.urls.getCompanyDataAnalysis,
            data: params,
        });
    }
    getCompanyAnalyticsEmailData(params) {
        return this.http.post({
            url: this.urls.getCompanyDataAnalysis,
            data: params,
        });
    }
    getCompanyDataAnalysisDetailData(params) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return this.http.post({
            url: this.urls.getCompanyDataAnalysisDetail,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        });
    }
    getCompanyDataAnalysisUsageDownload(params, report_name) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        // 使用format函数替换URL中的路径参数
        const url = format(this.urls.getCompanyDataAnalysisUsageDownload, { report_name });
        return this.http.request({
            url: url,
            method: 'post',
            responseType: 'blob',
            rawResponse: true,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        }).catch(async (err) => {
            // Blob 但是返回了JSON错误
            const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json';
            if (isJsonBlob(err.response?.data)) {
                const txt = await (err.response?.data)?.text();
                err.response.data = (typeof txt === 'string') ? JSON.parse(txt) : txt;
            }
            throw err;
        });
    }
    getCompanyDataAnalysisDashboard(params) {
        return this.http.post({
            url: this.urls.getCompanyDataAnalysisDashboard,
            data: params,
        });
    }
    getCompanyDataAnalysisKickedOutSummary(params) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return this.http.post({
            url: this.urls.getCompanyDataAnalysisKickedOutSummary,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        });
    }
    getCompanyDataAnalysisKickedOutDownload(params, report_name) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        const url = format(this.urls.getCompanyDataAnalysisKickedOutDownload, { report_name });
        return this.http.request({
            url: url,
            method: 'post',
            responseType: 'blob',
            rawResponse: true,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        }).catch(async (err) => {
            // Blob 但是返回了JSON错误
            const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json';
            if (isJsonBlob(err.response?.data)) {
                const txt = await (err.response?.data)?.text();
                err.response.data = (typeof txt === 'string') ? JSON.parse(txt) : txt;
            }
            throw err;
        });
    }
    postLoginOverviewUsageDownload(params) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return this.http.request({
            url: this.urls.postLoginOverviewUsageDownload,
            method: 'post',
            responseType: 'blob',
            rawResponse: true,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        }).catch(async (err) => {
            // Blob 但是返回了JSON错误
            const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json';
            if (isJsonBlob(err.response?.data)) {
                const txt = await (err.response?.data)?.text();
                err.response.data = (typeof txt === 'string') ? JSON.parse(txt) : txt;
            }
            throw err;
        });
    }
    postCompanyEurekaUsageDownload(params) {
        const { sEcho, iDisplayLength, iDisplayStart, ...otherParams } = params;
        return this.http.request({
            url: this.urls.postCompanyEurekaUsageDownload,
            method: 'post',
            responseType: 'blob',
            rawResponse: true,
            params: {
                sEcho: sEcho,
                iDisplayLength: iDisplayLength,
                iDisplayStart: iDisplayStart,
            },
            data: otherParams,
        }).catch(async (err) => {
            // Blob 但是返回了JSON错误
            const isJsonBlob = (data) => data instanceof Blob && data.type === 'application/json';
            if (isJsonBlob(err.response?.data)) {
                const txt = await (err.response?.data)?.text();
                err.response.data = (typeof txt === 'string') ? JSON.parse(txt) : txt;
            }
            throw err;
        });
    }
};
CompanyDataAnalysisApi = __decorate([
    injectable(),
    __param(0, inject(Symbols.BoHttp)),
    __param(1, inject(Symbols.CompanyDataAnalysisUrls)),
    __metadata("design:paramtypes", [Object, Object])
], CompanyDataAnalysisApi);
export { CompanyDataAnalysisApi };
